import { useState, useEffect } from "react";

/**
 * A custom hook that tracks whether a given media query matches the current viewport.
 * @param {string} query - The media query to match against
 * @returns {boolean} - Whether the media query matches
 * @example
 * const isMobile = useMediaQuery('(max-width: 768px)');
 */
function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    // Set initial value
    setMatches(media.matches);

    // Create event listener
    const listener = e => setMatches(e.matches);
    // Add listener
    media.addEventListener("change", listener);

    // Clean up
    return () => media.removeEventListener("change", listener);
  }, [query]);

  return matches;
}

export default useMediaQuery;
